export const brands = [
    {
      imageName: 'aurora.png',
      imgWidth: 180,
      imgHeight: 30,
    },
    {
      imageName: 'ayrloom.png',
      imgWidth: 155,
      imgHeight: 34,
    },
    {
      imageName: 'bloomwell.png',
      imgWidth: 184,
      imgHeight: 25,
    },
    {
      imageName: 'friendlybrand.png',
      imgWidth: 161,
      imgHeight: 54,
    },
    {
      imageName: 'blueriver.png',
      imgWidth: 104,
      imgHeight: 91,
    },
    {
      imageName: 'Tilray-logo.png',
      imgWidth: 171,
      imgHeight: 30,
    },
    {
      imageName: 'medipharm.png',
      imgWidth: 152,
      imgHeight: 89,
    },
    {
      imageName: 'holywater.png',
      imgWidth: 65,
      imgHeight: 80,
    },
    {
      imageName: 'ilios.png',
      imgWidth: 200,
      imgHeight: 57,
    },
    {
      imageName: 'trulieve.png',
      imgWidth: 183,
      imgHeight: 59,
    },
    {
      imageName: 'globaltrust.png',
      imgWidth: 232,
      imgHeight: 50,
    },
    {
      imageName: 'decibel.png',
      imgWidth: 83,
      imgHeight: 56,
    },
    {
      imageName: 'curaleaf.png',
      imgWidth: 162,
      imgHeight: 56,
    },
    {
      imageName: 'iris-labs-opt-512.png',
      imgWidth: 195,
      imgHeight: 38,
    },
    {
      imageName: 'verano.png',
      imgWidth: 156,
      imgHeight: 25,
    },
    {
      imageName: 'greybeard.png',
      imgWidth: 175,
      imgHeight: 53,
    },
    {
      imageName: 'rubicon.png',
      imgWidth: 211,
      imgHeight: 81,
    },
    {
      imageName: 'ipspharma.png',
      imgWidth: 132,
      imgHeight: 86,
    },
    {
      imageName: 'fullspec.png',
      imgWidth: 135,
      imgHeight: 78,
    },
    {
      imageName: 'commoncitizen.png',
      imgWidth: 134,
      imgHeight: 46,
    },
    {
      imageName: 'novafarms.png',
      imgWidth: 132,
      imgHeight: 53,
    },
    {
      imageName: 'jeeter.png',
      imgWidth: 145,
      imgHeight: 64,
    },
    {
      imageName: 'rosinlabs.png',
      imgWidth: 174,
      imgHeight: 81,
    },
    {
      imageName: 'arcatafire.png',
      imgWidth: 80,
      imgHeight: 65,
    },
    {
      imageName: 'vireo.png',
      imgWidth: 202,
      imgHeight: 31,
    },
    {
      imageName: 'c3industries.png',
      imgWidth: 325,
      imgHeight: 23,
    },
    {
      imageName: 'gooddayfarm.png',
      imgWidth: 172,
      imgHeight: 38,
    },
];
